const hotspotsTemplate = ({hotspotsContainerId}) => `<div id="${hotspotsContainerId}" class="hotspots"></div>`;

export default hotspotsTemplate;
